import type { TrendData } from "../hooks/useRankingTrends";

interface TrendIndicatorProps {
  trend: TrendData | null;
  showPercentage?: boolean;
  size?: "sm" | "md";
}

const TrendIndicator = ({ trend, showPercentage = true, size = "sm" }: TrendIndicatorProps) => {
  if (!trend) {
    return <span className="text-gray-400">-</span>;
  }

  const { value, isPositive } = trend;

  const colorClass = isPositive ? "text-green-600" : "text-red-600";
  const bgColorClass = isPositive ? "bg-green-50" : "bg-red-50";
  const sizeClass = size === "sm" ? "text-xs" : "text-sm";

  const ArrowIcon = isPositive ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={size === "sm" ? "h-3 w-3" : "h-4 w-4"}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={size === "sm" ? "h-3 w-3" : "h-4 w-4"}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );

  return (
    <span
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded ${bgColorClass} ${colorClass} ${sizeClass} font-medium`}
    >
      {ArrowIcon}
      {showPercentage && <span>{value}%</span>}
    </span>
  );
};

export default TrendIndicator;
